import React from "react";
import {
  fillDynamicLabels,
  unassignedWorkspacesFilter
} from "@/features/map/utils/utils-map";
import { MapEditPanel } from "@/features/map/components/MapEditPanel";
import { UseMapViewSvgEditReturn } from "@/features/map/components/MapView/MapViewSvg/useMapViewSvgEdit";
import { useMap } from "@/features/map/MapProvider";
import { isTacticStaff } from "@gettactic/helpers/src/featureFlags";
import { useAuthenticated } from "@gettactic/hooks";

export interface MapViewEditorPanelProps {
  editor: UseMapViewSvgEditReturn;
  onMapEditorSaved: () => void;
}

export const MapViewEditorPanel: React.FC<MapViewEditorPanelProps> = ({
  editor,
  onMapEditorSaved
}) => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  const { resources, floorsWithResources } = useMap();
  const isTacticStaffAuthenticatedUser = !!isTacticStaff(authenticatedUser);
  const floorSpecificResources = editor.floorSpecificResources;
  const mapEditAllMapResources = editor.mapEditAllMapResources;
  const unassignedWorkspaces = floorSpecificResources
    ? unassignedWorkspacesFilter(floorSpecificResources, mapEditAllMapResources)
    : [];
  const mapEditSelectedList = editor.selectedNodes;
  const addMapEditResourceSelected = editor.addMapEditResourceSelected;
  const clearMapEditSelected = editor.clearMapEditSelected;
  const triggerNonMatchOffice = editor.triggerNonMatchOffice;
  const triggerNonMatchFloor = editor.triggerNonMatchFloor;
  const nonOfficeMatchingMapResources = editor.nonOfficeMatchingMapResources;
  const nonFloorMatchingMapResources = editor.nonFloorMatchingMapResources;
  const triggerHasNFC = editor.triggerHasNFC;

  return (
    <div className="relative">
      <div className="pointer-events-none fixed top-0 right-0 z-modal flex h-full">
        <div className="pointer-events-auto w-screen max-w-[40rem]">
          <div className="relative flex h-full flex-col overflow-y-auto bg-white px-4 shadow-xl">
            <MapEditPanel
              floors={floorsWithResources}
              floorSpecificResources={floorSpecificResources}
              unassignedWorkspaces={unassignedWorkspaces}
              allOfficeResources={resources}
              allMapResources={mapEditAllMapResources}
              mapEditSelectedList={mapEditSelectedList}
              setMapEditSelected={addMapEditResourceSelected}
              clearMapEditSelected={clearMapEditSelected}
              setNonMatchingOffice={triggerNonMatchOffice}
              setNonMatchingFloor={triggerNonMatchFloor}
              setHasNFC={triggerHasNFC}
              nonOfficeMatchingMapResources={nonOfficeMatchingMapResources}
              nonFloorMatchingMapResources={nonFloorMatchingMapResources}
              isTacticStaffAuthenticatedUser={isTacticStaffAuthenticatedUser}
              notifyUpdateLabels={(updatedResources) => {
                fillDynamicLabels(
                  editor.svgMapEditRef.current as SVGElement,
                  updatedResources
                );
              }}
              onSaved={onMapEditorSaved}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
